import { AnyAction } from "redux";
import { FETCH_USERS, RECEIVE_USERS, SAVE_USER, SAVE_USER_SUCCESS, DELETE_USER, DELETE_USER_SUCCESS } from "../actionTypes";

interface UserState {
    isFetching: boolean;
    isSaving: boolean;
    users: any[];
}

const initialState: UserState = {
    isFetching: false,
    isSaving: false,
    users: [],
}

const userReducer = (state = initialState, action: AnyAction) => {
    switch (action.type) {
        case FETCH_USERS: return { ...state, isFetching: true };
        case RECEIVE_USERS: return { ...state, isFetching: false, users: action.payload };
        case SAVE_USER: return { ...state, isSaving: true };
        case SAVE_USER_SUCCESS: return { ...state, isSaving: false };
        case DELETE_USER: return { ...state, isSaving: true };
        case DELETE_USER_SUCCESS: return { ...state, isSaving: false };
        default: return state;
    }
}
export default userReducer;
